;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';
import { Card } from 'reactstrap';
import { Dictionaries } from '../i18n/i18n-config';
import { getI18nUtils } from '../i18n/i18n-utils';

type Props = {
  dictionary: Partial<Dictionaries>;
  division: string;
};

function SynergieDivisionTeaser({ dictionary, division = 'Synergie Interim' }: Props): JSX.Element {
  const { formatMessage } = getI18nUtils(dictionary);
  const divisionKey = division
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-');
  return (
    <Card body className="border d-none d-lg-block">
      <h3 className="card-title">{division}</h3>
      <p>{formatMessage({ id: `working-at-division-${divisionKey}-description` })}</p>
    </Card>
  );
}

export default SynergieDivisionTeaser;
